<template>
  <div class="interview-page-modal">
    <slot />
  </div>
</template>
<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({})
</script>
<style lang="postcss">
.interview-page-modal {
  background: #fff;
  border: 1px solid #e8ecf6;
  padding: 2rem;
  max-width: 90%;
}
</style>
